/** icons */
import { BsTwitch } from "react-icons/bs";
import { FaQuora, FaReddit, FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FiFacebook, FiYoutube } from "react-icons/fi";
import { SiSnapchat } from "react-icons/si";
import { TiSocialLinkedin } from "react-icons/ti";



export const InfluencerStatus = {
  approved: {
    background: "#14A41D14",
    color: "#14A41D",
    label: "Active",
    value: "active",
  },
  declined: {
    background: "#FF003314",
    color: "#DB002C",
    label: "Inactive",
    value: "inactive",
  },
  deleted: {
    background: "#FF003314",
    color: "#DB002C",
    label: "Inactive",
    value: "inactive",
  },
  pending: {
    background: "#FF003314",
    color: "#DB002C",
    label: "Inactive",
    value: "inactive",
  },
};

export const SocialMediaDetails = {
  instagram: {
    label: "Instagram",
    key: "instagram",
    placeholder: "Instagram Handle",
    icon: ({ size = "12px" }) => <FaInstagram size={size} />,
    bgColor: "#E300D414",
    color: "#E300D4",
  },
  facebook: {
    label: "Facebook",
    key: "facebook",
    placeholder: "Facebook Handle",
    icon: ({ size = "12px" }) => <FiFacebook size={size} />,
    bgColor: "#0866FF14",
    color: "#0866FF",
  },
  linkedin: {
    label: "LinkedIn",
    key: "linkedin",
    placeholder: "LinkedIn Handle",
    icon: ({ size = "12px" }) => <TiSocialLinkedin size={size} />,
    bgColor: "#0A66C214",
    color: "#0A66C2",
  },
  youtube: {
    label: "Youtube",
    key: "youtube",
    placeholder: "Youtube Handle",
    icon: ({ size = "12px" }) => <FiYoutube size={size} />,
    bgColor: "#FF003314",
    color: "#FF0033",
  },
  snapchat: {
    label: "Snapchat",
    key: "snapchat",
    placeholder: "Snapchat Handle",
    icon: ({ size = "12px" }) => <SiSnapchat size={size} />,
    bgColor: "#FFFC0014",
    color: "#9a8e06",
  },
  twitter: {
    label: "Twitter",
    key: "twitter",
    placeholder: "Twitter Handle",
    icon: ({ size = "12px" }) => <FaTwitter size={size} />,
    bgColor: "#1DA1F214",
    color: "#1DA1F2",
  },
  twitch: {
    label: "Twitch",
    key: "twitch",
    placeholder: "Twitch Handle",
    icon: ({ size = "12px" }) => <BsTwitch size={size} />,
    bgColor: "#9146FF14",
    color: "#9146FF",
  },
  reddit: {
    label: "Reddit",
    key: "reddit",
    placeholder: "Reddit Handle",
    icon: ({ size = "12px" }) => <FaReddit size={size} />,
    bgColor: "#FF450014",
    color: "#FF4500",
  },
  quora: {
    label: "Quora",
    key: "quora",
    placeholder: "Quora Handle",
    icon: ({ size = "12px" }) => <FaQuora size={size} />,
    bgColor: "#B92B2714",
    color: "#B92B27",
  },
};
